import React from 'react';
import styled from 'styled-components';

import {
  TextLink,
  Type,
  TypeList,
  TypeListItem,
} from '@spotify-internal/encore-creator-web';
import { gray10, gray50 } from '@spotify-internal/encore-foundation';

type Props = { children: string };

export const Heading3FontSize16 = styled(Type).attrs({
  forwardedAs: 'h3',
  variant: Type.body2,
  color: gray10,
})`
  font-size: 16px;
  font-weight: ${Type.bold};
  line-height: 24px;
`;

export const PFontSize16 = styled(Type).attrs({
  forwardedAs: 'p',
  variant: Type.body2,
  color: gray50,
})`
  font-size: 16px;
  line-height: 24px;
`;

export const Bullets = styled(TypeList)`
  padding: 0;
  list-style-position: outside;
  margin-left: 1em;
`;

export const Bullet = styled(TypeListItem).attrs({
  color: gray50,
  variant: Type.body1,
})``;

export const TextLinkUnderlined = styled(TextLink)`
  text-decoration: underline;
`;

export function Heading3(props: Props) {
  return (
    <Heading3FontSize16
      style={{
        paddingBottom: '3px',
      }}
    >
      {props.children}
    </Heading3FontSize16>
  );
}
